import React, { Component } from 'react'
import { Box, Chip } from '@mui/material'
import { Building01, Calendar, Code01 } from '@untitledui/icons'

export default class Tweet extends Component {
	constructor(props) {
		super(props)
	
		this.state = {
			renderThis: ''
		}
	}
	componentDidMount = () => {
		if(window.location.pathname === '/projects'){
			this.setState({renderThis: <Box sx={tweetContentStyles}>
			<Box sx={projectTitleStyles}>{this.props.resume.title}</Box>
			<Box sx={projectDateStyles}>{this.props.resume.startDate}</Box>
			<Box component="p" sx={projectDescriptionStyles}>{this.props.resume.description}</Box>
			<Box sx={tweetImageWrapperStyles}>
				<a href={this.props.resume.url} target='_blank' rel="noreferrer">
					<Box component="img" alt={this.props.resume.title} src={this.props.pic} />
				</a>
			</Box>
			<Box sx={technologiesListStyles}>
				{this.props.resume.technologies.map((tech, index) => (
					<Chip 
						key={index}
						icon={<i className={tech.class} style={{ fontSize: '16px', marginLeft: '4px' }}></i>}
						label={tech.name}
						sx={techChipStyles}
						size="small"
					/>
				))}
			</Box>
		</Box>})
		}else if(window.location.pathname === '/skills'){
			this.setState({renderThis: <Box sx={tweetContentStyles}>
			<Box sx={skillsHeaderStyles}>
				<Code01 sx={skillsHeaderIconStyles} />
				<Box component="span" sx={skillsBlurbStyles}>{this.props.skills.skills_blurb}</Box>
			</Box>
			<Box sx={skillsGridStyles}>
				{this.props.skills.icons.reverse().map((icon, index) => (
					<Box key={index} sx={skillItemStyles}>
						<i className={icon.class} style={{ fontSize: '28px', marginRight: '8px' }}></i>
						<Box component="span" sx={skillNameStyles}>{icon.name}</Box>
					</Box>
				))}
			</Box>
		</Box>})
		}else if(window.location.pathname === '/experience'){
			this.setState({renderThis: <Box sx={tweetContentStyles}>
			<Box sx={experienceHeaderStyles}>
				<Building01 sx={experienceIconStyles} />
				<Box sx={experienceCompanyStyles}>{this.props.experience.company}</Box>
			</Box>
			<Box sx={experienceTitleStyles}>{this.props.experience.title}</Box>
			<Box sx={experienceDateStyles}>
				<Calendar sx={calendarIconStyles} />
				<Box component="span">{this.props.experience.years}</Box>
			</Box>
			<Box sx={technologiesListStyles}>
				{this.props.experience.technologies.reverse().map((tech, index) => (
					<Chip 
						key={index} 
						label={tech} 
						sx={techChipStyles}
						size="small"
					/>
				))}
			</Box>
		</Box>})
		} 
	}
	render() {
		return (
			<>
				{this.state.renderThis}
			</>
		)
	}
}

const tweetContentStyles = {
	marginTop: '4px',
	marginBottom: '12px',
	fontSize: '15px',
	lineHeight: '20px',
	color: '#0f1419',
	wordWrap: 'break-word',
	overflowWrap: 'break-word',
	'& h6': {
		fontSize: '15px',
		fontWeight: 400,
		color: '#0f1419',
		margin: '0 0 12px 0',
		lineHeight: '20px',
	},
	'& p': {
		fontSize: '15px',
		lineHeight: '20px',
		color: '#0f1419',
		margin: '0 0 12px 0',
		wordWrap: 'break-word',
		overflowWrap: 'break-word',
	},
};

const tweetImageWrapperStyles = {
	margin: '12px 0',
	borderRadius: '16px',
	overflow: 'hidden',
	border: '1px solid #e1e8ed',
	backgroundColor: '#000',
	'& a': {
		display: 'block',
		textDecoration: 'none',
	},
	'& img': {
		width: '100%',
		height: 'auto',
		display: 'block',
		maxHeight: '510px',
		objectFit: 'cover',
	},
};


const skillsHeaderStyles = {
	display: 'flex',
	alignItems: 'center',
	gap: '8px',
	marginBottom: '16px',
};

const skillsHeaderIconStyles = {
	width: '20px',
	height: '20px',
	color: '#1d9bf0',
	flexShrink: 0,
};

const skillsBlurbStyles = {
	fontSize: '15px',
	lineHeight: '20px',
	color: '#0f1419',
	fontWeight: 500,
};

const skillsGridStyles = {
	display: 'grid',
	gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))',
	gap: '12px',
	marginTop: '8px',
};

const skillItemStyles = {
	display: 'flex',
	alignItems: 'center',
	padding: '10px 12px',
	backgroundColor: '#f7f9fa',
	borderRadius: '12px',
	border: '1px solid #e1e8ed',
	transition: 'all 0.2s',
	'&:hover': {
		backgroundColor: '#eff3f4',
		borderColor: '#1d9bf0',
	},
};

const skillNameStyles = {
	fontSize: '14px',
	fontWeight: 500,
	color: '#0f1419',
	lineHeight: '20px',
};

const experienceHeaderStyles = {
	display: 'flex',
	alignItems: 'center',
	gap: '8px',
	marginBottom: '8px',
};

const experienceIconStyles = {
	width: '20px',
	height: '20px',
	color: '#1d9bf0',
	flexShrink: 0,
};

const experienceCompanyStyles = {
	fontSize: '17px',
	fontWeight: 700,
	color: '#0f1419',
	lineHeight: '24px',
};

const experienceTitleStyles = {
	fontSize: '15px',
	fontWeight: 500,
	color: '#0f1419',
	marginBottom: '8px',
	lineHeight: '20px',
};

const experienceDateStyles = {
	display: 'flex',
	alignItems: 'center',
	gap: '6px',
	marginBottom: '16px',
	fontSize: '14px',
	color: '#536471',
	lineHeight: '20px',
};

const calendarIconStyles = {
	width: '16px',
	height: '16px',
	color: '#536471',
};

const technologiesListStyles = {
	display: 'flex',
	flexWrap: 'wrap',
	gap: '8px',
	marginTop: '12px',
};

const projectTitleStyles = {
	fontSize: '17px',
	fontWeight: 700,
	color: '#0f1419',
	lineHeight: '24px',
	marginBottom: '4px',
};

const projectDateStyles = {
	fontSize: '14px',
	color: '#536471',
	lineHeight: '20px',
	marginBottom: '12px',
};

const projectDescriptionStyles = {
	fontSize: '15px',
	lineHeight: '20px',
	color: '#0f1419',
	margin: '0 0 12px 0',
	wordWrap: 'break-word',
	overflowWrap: 'break-word',
};

const techChipStyles = {
	backgroundColor: '#f7f9fa',
	color: '#0f1419',
	border: '1px solid #e1e8ed',
	fontSize: '13px',
	fontWeight: 500,
	height: '28px',
	'&:hover': {
		backgroundColor: '#eff3f4',
		borderColor: '#1d9bf0',
	},
	'& .MuiChip-label': {
		padding: '0 10px',
	},
};
